export default __webpack_public_path__ + "static/media/13.6ec94ce9.png";